var _circle, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecentTimer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.46265,
    cy: 9,
    r: 9,
    fill: "#CBE1F4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6626_42538",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 15,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.46265,
    y: 2,
    width: 14,
    height: 14,
    fill: "#4A7495"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6626_42538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.4627 14.5418C8.12706 14.5418 6.95329 14.1282 5.9414 13.3011C4.92951 12.4739 4.29344 11.4209 4.03317 10.1422C4.00556 10.018 4.02914 9.90715 4.1039 9.80954C4.17867 9.71193 4.27812 9.65529 4.40228 9.63964C4.52643 9.62389 4.63581 9.6534 4.7304 9.72816C4.825 9.80293 4.88912 9.90239 4.92276 10.0265C5.1591 11.0848 5.69849 11.9561 6.54092 12.6405C7.38345 13.3247 8.35738 13.6668 9.4627 13.6668C10.7655 13.6668 11.8689 13.2147 12.7731 12.3106C13.6773 11.4064 14.1294 10.3029 14.1294 9.00016C14.1294 7.69738 13.6773 6.59391 12.7731 5.68975C11.8689 4.78558 10.7655 4.3335 9.4627 4.3335C8.58546 4.3335 7.77832 4.55881 7.04128 5.00943C6.30424 5.45996 5.73607 6.07786 5.33678 6.86312H6.62463C6.74849 6.86312 6.85238 6.90507 6.93628 6.98898C7.02008 7.07288 7.06199 7.17686 7.06199 7.30091C7.06199 7.42487 7.02008 7.52875 6.93628 7.61256C6.85238 7.69627 6.74849 7.73812 6.62463 7.73812H4.82359C4.62944 7.73812 4.47495 7.65961 4.36013 7.5026C4.24541 7.34549 4.22208 7.17909 4.29013 7.00341C4.69467 5.94593 5.36682 5.09071 6.30657 4.43777C7.24622 3.78492 8.29826 3.4585 9.4627 3.4585C10.2293 3.4585 10.9497 3.60394 11.6239 3.89483C12.2982 4.18572 12.8847 4.58049 13.3834 5.07914C13.8822 5.57779 14.277 6.16419 14.5679 6.83833C14.8589 7.51247 15.0044 8.23274 15.0044 8.99914C15.0044 9.76564 14.8589 10.4861 14.5679 11.1605C14.277 11.835 13.8822 12.4216 13.3834 12.9205C12.8847 13.4193 12.2982 13.8143 11.6239 14.1054C10.9497 14.3963 10.2293 14.5418 9.4627 14.5418ZM9.9002 8.82298L11.3585 10.2869C11.4393 10.3664 11.4797 10.4676 11.4797 10.5905C11.4797 10.7134 11.4393 10.8161 11.3585 10.8988C11.2777 10.9814 11.1753 11.0218 11.0511 11.02C10.927 11.0181 10.8245 10.9768 10.7438 10.896L9.18503 9.33718C9.12932 9.28148 9.08878 9.22144 9.0634 9.15708C9.03793 9.09272 9.0252 9.02622 9.0252 8.95758V6.7342C9.0252 6.61025 9.06715 6.50632 9.15105 6.42241C9.23495 6.33861 9.33888 6.2967 9.46284 6.2967C9.5869 6.2967 9.69078 6.33861 9.77449 6.42241C9.85829 6.50632 9.9002 6.61025 9.9002 6.7342V8.82298Z",
    fill: "#4A7495"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentTimer);
export default __webpack_public_path__ + "static/media/recentTimer.c431207bfe88e7beef3d96a608f23de5.svg";
export { ForwardRef as ReactComponent };